const info = {
  ZH: { //中文翻译
    personInfo: '个人中心',
    changePassword: "修改密码",
    oldPassword: "旧密码",
    newPassword: "新密码",
    reconfirm: '再次确认',
    starLevel:'星级',
    customerServiceInformation:"客服信息",
    contactPhone:"联系电话（微信同号）",
    bingScipAccount:"绑定scip账号",
  },
  EN: { //英文翻译
    personInfo: 'Personal Information',
    changePassword: "Change Password",
    oldPassword: "old Password",
    newPassword: "New Password",
    reconfirm: 'Reconfirm',
    starLevel:'Star Level',
    customerServiceInformation:"Customer Service Information",
    contactPhone:"Contact Phone Number (same as WeChat)",
    bingScipAccount:"Bind Scip Account",
  }
}
export default info //需要暴露出去
